var agi = agi || {};
agi.expressions = agi.expressions || {};

(function(EventDispatcher) {
    "use strict";
    var Express = function Express() {
        throw "Express cannot be instantiated.";
    };

    Express.dispatcher = {};
    Express.personalizations = {};
    EventDispatcher.initialize(Express.dispatcher);

    if(!agi.expressions.ExpressEvent) {
        throw new Error("Failed to access ExpressEvent. Cannot continue.");
    } else {
        var ExpressEvent = agi.expressions.ExpressEvent;
    }

    var hasListener = function hasListener(name) {
        return Express.dispatcher.hasEventListener.call(Express.dispatcher,
            name);
    };

    var dispatchEvent = function dispatchEvent(type, data) {
        if(hasListener(type)) {
            var event = new ExpressEvent(type);
            event.data = data;
            Express.dispatcher.dispatchEvent.call(Express.dispatcher, event);
        }
    };

    var throwArgError = function throwArgError(funcName, arg, expected) {
        var msg = funcName + " received invalid argument, " + arg + ". ";
        msg += "Expected " + expected + ".";
        throw new Error(msg);
    };

    Express.addCSSAnimateSeq = function addCSSAnimateSeq(obj) {
        dispatchEvent("addCSSAnimateSeq", obj);
    };

    Express.addAnImage = function addAnImage(target, id, width, height, callback) {
        if(typeof target !== "object") {
            throwArgError("addAnImage", target, "object");
        } else if(typeof id !== "string") {
            throwArgError("addAnImage", id, "string");
        } else if(typeof width !== "number") {
            throwArgError("addAnImage", width, "number");
        } else if(typeof height !== "number") {
            throwArgError("addAnImage", height, "number");
        }

        dispatchEvent("addAnImage", {
            id:id, target:target, width:width, height:height,
            callback: callback
            });
    };

    // TODO (Phil) Consider rolling state like this into a separate module.
    Express.audioIsPlaying = false;

    Express.endVideo = function endVideo() {
        dispatchEvent("endVideo", {});
    };

    Express.hideCanvas = function hideCanvas() {
        dispatchEvent("hideCanvas", {});
    };

    Express.hideIfNotAMember = function hideIfNotAMember(symbol) {
        if(typeof symbol !== "object") {
            throwArgError("hideIfNotAMember", symbol, "object");
        }
        dispatchEvent("hideIfNotAMember", {displayObject:symbol});
    };

    Express.hideOnPickup = function hideOnPickup(symbol) {
        if(typeof symbol !== "object") {
            throwArgError("hideOnPickup", symbol, "object");
        }
        dispatchEvent("hideOnPickup", {displayObject:symbol});
    };

    Express.hideOnInit = function hideOnInit(symbol) {
        if(typeof symbol !== "object") {
            throwArgError("hideOnInit", symbol, "object");
        }
        dispatchEvent("hideOnInit", {displayObject:symbol});
    };

    Express.insertImage = function insertImage(key, target, width, height) {
        if(typeof key !== "string") {
            throwArgError("insertImage", key, "string");
        } else if(typeof target !== "object") {
            throwArgError("insertImage", target, "object");
        }
        dispatchEvent("insertImage", {
            key:key, target:target, width:width, height:height
        });
    };

    Express.insertSelection = function insertSelection(key, target) {
        if(typeof key !== "string") {
            throwArgError("insertSelection", key, "string");
        } else if(typeof target !== "object") {
            throwArgError("insertSelection", target, "object");
        }
        dispatchEvent("insertSelection", {
            key:key, target:target
        });
    };

    Express.insertPersonalization = function insertPersonalization(
        key, target) {
        if(typeof key !== "string") {
            throwArgError("insertPersonalization", key, "string");
        } else if(typeof target !== "object") {
            throwArgError("insertPersonalization", target, "object");
        }
        dispatchEvent("insertPersonalization", {
            key:key, target:target
        });
    };

    Express.playAudio = function playAudio(audioName, loopCount, timeDelay) {
        if(typeof audioName !== "string") {
            throwArgError("playAudio", audioName, "string");
        }
        dispatchEvent(
            "playAudio", {name:audioName, loops:loopCount, delay:timeDelay});
        Express.audioIsPlaying = true;
    };

    Express.removeCSSAnimateSeq = function removeCSSAnimateSeq(obj) {
        dispatchEvent("removeCSSAnimateSeq", obj);
    }

    Express.replay = function replay() {
        dispatchEvent("replay", {});
    };

    Express.seekAndResumeVideo = function seekAndResumeVideo(obj) {
        dispatchEvent("seekAndResumeVideo", obj);
    };

    Express.send = function send() {
        dispatchEvent("send", {});
    };

    Express.showCanvas = function showCanvas() {
        dispatchEvent("showCanvas", {});
    };

    Express.showSelectBox = function showSelectBox(target, name, options) {
        if(typeof target !== "object") {
            throwArgError("showSelectBox", target, "object");
        } else if(typeof name !== "string") {
            throwArgError("showSelectBox", name, "string");
        } else if(typeof options !== "object") {
            throwArgError("showSelectBox", options, "object");
        }
        dispatchEvent("showSelectBox", {
            target:target, name:name, options:options
            });
    };

    Express.showTextInput = function showTextInput(text, name, suffix, x, y) {
        if(typeof text !== "object") {
            throwArgError("showTextInput", text, "object");
        }
        dispatchEvent("showTextInput", {text:text, name:name, suffix:suffix, x:x, y:y});
    };

    Express.stopAudio = function stopAudio(audioName) {
        if(typeof audioName !== "string") {
            throwArgError("stopAudio", audioName, "string");
        }
        dispatchEvent("stopAudio", {name:audioName});
        Express.audioIsPlaying = false;
    };

    Express.submitInput = function submitInput(checkRequiredPers) {
        var check = (checkRequiredPers === undefined) ? true : checkRequiredPers;
        dispatchEvent("submitInput", {checkRequiredPers: check});
    };

    agi.expressions.Express = Express;

}(createjs.EventDispatcher));
